import { __generator } from "tslib";
import { put, select } from 'redux-saga/effects';
import { selectors, withOffset } from '../../Stream';
import { getTierDeviationsStreamId } from '../helpers';
import { getCurrentMediaSource, getCurrentTierId } from '../selectors';
export default function (action) {
    var _a, mediaSource, tierId, streamId, isFetching;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, select(function (state) { return ({
                    mediaSource: getCurrentMediaSource(state),
                    tierId: getCurrentTierId(state),
                }); })];
            case 1:
                _a = _b.sent(), mediaSource = _a.mediaSource, tierId = _a.tierId;
                streamId = getTierDeviationsStreamId(mediaSource, tierId);
                return [4 /*yield*/, select(function (state) {
                        return selectors.isFetching(state, streamId);
                    })];
            case 2:
                isFetching = _b.sent();
                if (isFetching) {
                    return [2 /*return*/];
                }
                return [4 /*yield*/, put(withOffset.actions.fetch(streamId))];
            case 3:
                _b.sent();
                return [2 /*return*/];
        }
    });
}
//# sourceMappingURL=fetchMoreTierDeviations.js.map